"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Entity = void 0;
var tslib_1 = require("tslib");
var signal_1 = require("@yoieh/signal");
var Entity = /** @class */ (function () {
    function Entity(entityId) {
        this.onComponentAdded = new signal_1.Signal();
        this.onComponentRemoved = new signal_1.Signal();
        this._components = [];
        this.id = entityId;
        this._components = [];
    }
    Object.defineProperty(Entity.prototype, "components", {
        get: function () {
            return this._components;
        },
        enumerable: false,
        configurable: true
    });
    Entity.prototype.add = function (component) {
        this.addComponent(component);
        return this;
    };
    Entity.prototype.addComponent = function (component) {
        // overtides component if already exists
        this._components = (0, tslib_1.__spreadArray)((0, tslib_1.__spreadArray)([], (0, tslib_1.__read)(this.components.filter(function (c) { return c.constructor.name !== component.constructor.name; })), false), [component], false);
        this.onComponentAdded.dispatch(this, component);
    };
    Entity.prototype.remove = function (constr) {
        this.removeComponent(constr);
        return this;
    };
    Entity.prototype.removeComponent = function (constr) {
        this._components = this.components.filter(function (c) { return !(c instanceof constr); });
        this.onComponentRemoved.dispatch(constr);
    };
    Entity.prototype.get = function (constr) {
        var component = this.components.find(function (c) { return c instanceof constr; });
        if (component) {
            return component;
        }
        throw new Error("Component ".concat(constr.name, " not found on Entity ").concat(this.constructor.name));
    };
    Entity.prototype.has = function (constr) {
        return this.components.find(function (c) { return c instanceof constr; }) !== undefined;
    };
    Entity.prototype.hasAll = function () {
        var _this = this;
        var constrs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            constrs[_i] = arguments[_i];
        }
        return constrs.every(function (c) { return _this.has(c); });
    };
    Entity.prototype.hasAny = function () {
        var _this = this;
        var constrs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            constrs[_i] = arguments[_i];
        }
        return constrs.some(function (c) { return _this.has(c); });
    };
    Entity.prototype.hasNone = function () {
        var constrs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            constrs[_i] = arguments[_i];
        }
        return !this.hasAny.apply(this, (0, tslib_1.__spreadArray)([], (0, tslib_1.__read)(constrs), false));
    };
    return Entity;
}());
exports.Entity = Entity;
exports.default = Entity;
